import React from "react";
import errorpage from "../NotFound/images/The404-error.jpg"

const NotFound = () => {
  return <div>
      <img style={{width: "100%"}} src={errorpage} alt="404: Page not Found" />
  </div>;
};

export default NotFound;
